import { v4 as uuid } from "uuid";

export const categories = [
  {
    _id: uuid(),
    categoryName: "Organic Fruits",
    categoryIdentifier: "organicFruits",
    imgSrc: "https://ik.imagekit.io/mandeshiagro/assets/product-categories/fruit_c8Fr32hpAS.png?ik-sdk-version=javascript-1.4.3&updatedAt=1648264697986"
  },
  {
    _id: uuid(),
    categoryName: "Organic Dairy Products",
    categoryIdentifier: "organicDairy",
    imgSrc: "https://ik.imagekit.io/mandeshiagro/assets/product-categories/cow_1mPGZGQTG.png?ik-sdk-version=javascript-1.4.3&updatedAt=1648264695264"
  },
  {
    _id: uuid(),
    categoryName: "Wood Pressed Oils",
    categoryIdentifier: "organicOils",
    imgSrc: "https://ik.imagekit.io/mandeshiagro/assets/product-categories/sunflower-oil_rM0BIfwy0.png?ik-sdk-version=javascript-1.4.3&updatedAt=1648264700682"
  },
  {
    _id: uuid(),
    categoryName: "Organic Spices",
    categoryIdentifier: "organicSpices",
    imgSrc: "https://ik.imagekit.io/mandeshiagro/assets/product-categories/chilli_hRtccTPly.png?ik-sdk-version=javascript-1.4.3&updatedAt=1648264667751"
  },
  {
    _id: uuid(),
    categoryName: "Organic Vegetables",
    categoryIdentifier: "organicVegetables",
    imgSrc: "https://ik.imagekit.io/mandeshiagro/assets/product-categories/vegetables_OWNdCPYS4.png?ik-sdk-version=javascript-1.4.3&updatedAt=1648264693498"
  },
  {
    _id: uuid(),
    categoryName: "Organic Groceries",
    categoryIdentifier: "organicGroceries",
    imgSrc: "https://ik.imagekit.io/mandeshiagro/assets/product-categories/rice_7degCcLY_O.png?ik-sdk-version=javascript-1.4.3&updatedAt=1648264698024"
  }
];
